import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import dynamic from "next/dynamic";

import { ADDONS_WITH_VARIANTS, getWidgetSpecificProps } from "@utils/index";
import { isEmpty } from "@utils/lodash";
import { CommonProps } from "@utils/interface";
import { ADDONS_CAR } from "@utils/index";
import { useRouter } from "next/router";
import { analyticEvents as triggerAnalyticEvent } from "@actions/analyticEvents";
import { setAnalytics } from "@actions/setAnalyticsData";
import { getRequestpayload } from "@utils/index";

interface IAddonVariantsModal extends CommonProps {
  variants: any;
  addonId: string;
  selectedVariantId: string | null;
  defaultVariantIdSelection: string;
  isAddonSelected?: boolean;
  addonVariantModalContent: any;
  isNudge?: boolean;
  isUpgradeModal?: boolean;
  isUserApplied?: boolean;
}

const PaCoverVariantsModal = dynamic(() => import("./paCoverVariantsModal"));

const AddonVarinatsModal = dynamic(() => import("./addonVariantsModal"));

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const AddonVariantModals = (props: IAddonVariantsModal) => {
  const router = useRouter();
  const { proposal_ekey, current_node } = router?.query;

  const { selectedPrice, selectedAddons } = useSelector(
    ({ globalState }: any) => {
      return {
        selectedAddons: globalState?.payloadData.selected_addons || [],
        selectedPrice: globalState?.price
      };
    }
  );

  const {
    id,
    variants,
    addonId,
    selectedVariantId,
    defaultVariantIdSelection,
    // is_addon_selected,
    addonVariantModalContent,
    is_visible,
    actions,
    isNudge,
    isUpgradeModal,
    lockBackgroundInteraction = true,
    isUserApplied = false
  } = props;

  const {
    on_modal_close,
    primary_cta_on_click,
    secondary_cta_on_click,
    nudge_primary_cta_on_click,
    nudge_secondary_cta_on_click,
    on_load
  } = actions || {};

  useEffect(() => {
    if (is_visible && on_load?.length > 0) {
      on_load?.forEach((eachFunc: any) => {
        typeof eachFunc.funCall === "function" &&
          eachFunc.funCall(eachFunc.args);
      });
    }
  }, [is_visible]);

  const primaryCtaClickHandler = (selectedVariant) => {
    let updatedPrice;
    let updatedAddons;

    updatedPrice = selectedPrice;
    updatedAddons = [...selectedAddons];

    const isAddonSelected = !isEmpty(
      selectedAddons.find((a) => a?.id === addonId)
    );
    if (isAddonSelected) {
      for (let i = 0; i < selectedAddons?.length; i++) {
        if (selectedAddons[i]?.id === addonId) {
          const currentVariantPrice = variants.find(
            (v) => v?.variant_id === selectedAddons[i]?.variant_id
          )?.price?.net_premium;

          updatedPrice =
            updatedPrice -
            currentVariantPrice +
            selectedVariant.price.net_premium;
        }
      }
    } else {
      updatedPrice += selectedVariant.price.net_premium;
    }

    updatedAddons = updatedAddons?.filter((item) => {
      return item.id !== addonId;
    });
    updatedAddons.push({
      id: addonId,
      variant_id: selectedVariant?.variant_id,
      tenure: selectedVariant?.tenure
    });

    const requestBody = {
      current_node: current_node,
      expected_node: current_node
    };

    const data = {
      interaction: "add",
      id: addonId,
      addon_variant_id: selectedVariant?.variant_id,
      proposal_ekey: proposal_ekey
    };

    if (!isNudge) {
      if (
        primary_cta_on_click?.[0] &&
        typeof primary_cta_on_click[0].funCall === "function"
      ) {
        primary_cta_on_click?.forEach((eachFunc: any) => {
          eachFunc.funCall(
            //@ts-ignore
            {
              ...eachFunc.args,
              payloadData: { selected_addons: updatedAddons },
              globalData: { price: updatedPrice },
              requestBody: { ...eachFunc.args.requestBody, ...requestBody },
              data: { ...eachFunc.args.data, ...data },
              customData: {
                addon_variant_id: selectedVariant?.variant_id,
                add_on_id: addonId
              }
            } || {}
          );
        });
      }
    } else {
      if (
        nudge_primary_cta_on_click?.[0] &&
        typeof nudge_primary_cta_on_click[0].funCall === "function"
      ) {
        nudge_primary_cta_on_click?.forEach((eachFunc: any) => {
          eachFunc.funCall(
            //@ts-ignore
            {
              ...eachFunc.args,
              payloadData: { selected_addons: updatedAddons },
              globalData: { price: updatedPrice },
              requestBody: { ...eachFunc.args.requestBody },
              data: { ...eachFunc.args.data, ...data },
              customData: {
                addon_variant_id: selectedVariant?.variant_id,
                add_on_id: addonId
              }
            } || {}
          );
        });
      }
    }

    setAnalytics({
      variant_name: null
    });
  };

  const secondaryCtaClickHandler = (selectedVariant) => {
    let updatedPrice;
    let updatedAddons;
    if (!isEmpty(selectedAddons)) {
      updatedPrice = selectedPrice;
      updatedAddons = [...selectedAddons];
    }

    const requestBody = {
      current_node: current_node,
      expected_node: current_node
    };

    const data = {
      interaction: "remove",
      id: addonId,
      addon_variant_id: selectedVariant?.variant_id,
      proposal_ekey: proposal_ekey
    };

    const currentSelectedVariant = variants?.find(
      (v) =>
        v?.variant_id ===
        selectedAddons?.find((a) => a?.id === addonId)?.variant_id
    );

    if (!isNudge) {
      updatedPrice -= currentSelectedVariant?.price?.net_premium;
      updatedAddons = updatedAddons?.filter((item) => {
        return item.id !== addonId;
      });

      if (
        secondary_cta_on_click?.[0] &&
        typeof secondary_cta_on_click[0].funCall === "function"
      ) {
        secondary_cta_on_click?.forEach((eachFunc: any) => {
          eachFunc.funCall(
            //@ts-ignore
            {
              ...eachFunc.args,
              payloadData: { selected_addons: updatedAddons },
              globalData: { price: updatedPrice },
              requestBody: { ...eachFunc.args.requestBody },
              data: { ...eachFunc.args.data, ...data },
              customData: {
                addon_variant_id: selectedVariant?.variant_id,
                add_on_id: addonId
              }
            } || {}
          );
        });
      }
    } else {
      nudge_secondary_cta_on_click?.forEach((eachFunc: any) => {
        eachFunc.funCall(
          //@ts-ignore
          {
            ...eachFunc.args,
            payloadData: { selected_addons: updatedAddons },
            globalData: { price: updatedPrice },
            requestBody: { ...eachFunc.args.requestBody },
            data: { ...eachFunc.args.data, ...data },
            customData: {
              addon_variant_id: selectedVariant?.variant_id,
              add_on_id: addonId
            }
          } || {}
        );
      });
    }

    setAnalytics({
      variant_name: null
    });
  };

  const onClose = () => {
    if (
      on_modal_close?.[0] &&
      typeof on_modal_close[0].funCall === "function"
    ) {
      on_modal_close[0].funCall(on_modal_close[0].args || {});
    }
    const { data, journey } = getRequestpayload();
    if (!isNudge) {
      triggerAnalyticEvent({
        edata: {
          product: data.product,
          action_name: "tap_btn_add_on_nudge_skipped",
          action_type: "tap_btn",
          add_on_name: addonId
        },
        odata: {
          journey
        },
        event_name: "action"
      });
    }
    setAnalytics({
      variant_name: null
    });
  };

  const getSelectedVariantId = (addonId) => {
    if (isUserApplied) {
      return selectedVariantId;
    } else {
      const selectedCoverVariantId = selectedAddons?.find(
        (a) => a?.id === addonId
      )?.variant_id;

      if (!isEmpty(selectedCoverVariantId)) {
        return selectedCoverVariantId;
      } else {
        return selectedVariantId;
      }
    }
  };

  return isEmpty(variants) || variants?.length === 0 ? null : (
    <>
      <PaCoverVariantsModal
        showModal={addonId === ADDONS_CAR.PA_COVER && is_visible}
        variants={variants}
        primaryCtaClickHandler={primaryCtaClickHandler}
        secondaryCtaClickHandler={secondaryCtaClickHandler}
        isUpgradeModal={isUpgradeModal}
        isCoverSelected={
          isUserApplied ||
          !isEmpty(selectedAddons?.find((a) => a?.id === ADDONS_CAR.PA_COVER))
        }
        modalContent={addonVariantModalContent[ADDONS_CAR.PA_COVER]}
        handleClose={onClose}
        isNudge={isNudge}
        selectedVariantId={getSelectedVariantId(ADDONS_CAR.PA_COVER)}
        defaultVariantIdSelection={defaultVariantIdSelection}
        addonId={addonId}
        id={id}
        lockBackgroundInteraction={lockBackgroundInteraction}
      />

      {ADDONS_WITH_VARIANTS.map((addon_id) => {
        return (
          <AddonVarinatsModal
            lockBackgroundInteraction={lockBackgroundInteraction}
            showModal={addonId === ADDONS_CAR[addon_id] && is_visible}
            primaryCtaClickHandler={primaryCtaClickHandler}
            secondaryCtaClickHandler={secondaryCtaClickHandler}
            selectedVariantId={getSelectedVariantId(ADDONS_CAR[addon_id])}
            defaultVariantIdSelection={defaultVariantIdSelection}
            addonId={addonId}
            id={id}
            isCoverSelected={
              isUserApplied ||
              !isEmpty(
                selectedAddons?.find((a) => a?.id === ADDONS_CAR[addon_id])
              )
            }
            modalContent={addonVariantModalContent[ADDONS_CAR[addon_id]]}
            variants={variants}
            handleClose={onClose}
            isUpgradeModal={isUpgradeModal}
          />
        );
      })}
    </>
  );
};

export default connect(mapStateToProps)(AddonVariantModals);
